module.exports = __webpack_public_path__ + "static/media/Endurance.7ab8ab08.jpg";